const getNextRedo = (rootState) => rootState.ws.history.redo[0];

export default getNextRedo;
